var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMoneyMarketAccount = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28296_23855)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_28296_23855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0833 15.8333C20.9954 15.8333 24.1667 14.5275 24.1667 12.9167C24.1667 11.3058 20.9954 10 17.0833 10C13.1713 10 10 11.3058 10 12.9167C10 14.5275 13.1713 15.8333 17.0833 15.8333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1758 19.9734C16.7292 18.7993 17.5608 17.7851 18.5875 17.0126C18.0892 17.0551 17.5875 17.0834 17.0833 17.0834C14.3242 17.0834 11.5492 16.4443 10 15.2109V17.0834C10 18.5676 12.6933 19.7893 16.1758 19.9734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4167 23.3347C15.4167 22.5914 15.5267 21.8747 15.7192 21.1922C13.4408 21.0172 11.2925 20.4081 10 19.3789V21.2514C10 22.6314 12.3292 23.7839 15.455 24.0872C15.4317 23.8397 15.4167 23.5889 15.4167 23.3347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3327 16.668C19.6568 16.668 16.666 19.6588 16.666 23.3346C16.666 27.0105 19.6568 30.0013 23.3327 30.0013C27.0085 30.0013 29.9994 27.0105 29.9994 23.3346C29.9994 19.6588 27.0085 16.668 23.3327 16.668ZM23.016 22.7096H23.6493C24.6235 22.7096 25.416 23.5021 25.416 24.4763C25.416 25.3521 24.7843 26.073 23.9577 26.2196V26.8755C23.9577 27.2205 23.6777 27.5005 23.3327 27.5005C22.9877 27.5005 22.7077 27.2205 22.7077 26.8755V26.2513H21.8743C21.5293 26.2513 21.2493 25.9713 21.2493 25.6263C21.2493 25.2813 21.5293 25.0013 21.8743 25.0013H23.6493C23.9343 25.0013 24.166 24.7696 24.166 24.4846C24.166 24.1913 23.9343 23.9596 23.6493 23.9596H23.016C22.0418 23.9596 21.2493 23.1671 21.2493 22.193C21.2493 21.3171 21.881 20.5963 22.7077 20.4496V19.793C22.7077 19.448 22.9877 19.168 23.3327 19.168C23.6777 19.168 23.9577 19.448 23.9577 19.793V20.418H24.791C25.136 20.418 25.416 20.698 25.416 21.043C25.416 21.388 25.136 21.668 24.791 21.668H23.016C22.731 21.668 22.4993 21.8996 22.4993 22.1846C22.4993 22.478 22.731 22.7096 23.016 22.7096Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28296_23855"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_28296_23855"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMoneyMarketAccount);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_money_market_account.50d8eadafc93dbcc2b5c3024a451d709.svg";